/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

export default function usePersistentState (name, defaultValue) {
    const localStorageValue = JSON.parse(window.localStorage.getItem(name));
    const [value, setValue] = useState(localStorageValue || defaultValue);

    useEffect(() => {
        window.localStorage.setItem(name, JSON.stringify(value));
    }, [value]);

    return [
        value,
        setValue,
    ];
}
